export const LOGIN_MODAL_ID = 'LOGIN_MODAL_ID';
export const SIGNUP_MODAL_ID = 'SIGNUP_MODAL_ID';
export const SOCIAL_LOGIN_MODAL_ID = 'SOCIAL_LOGIN_MODAL_ID';
export const FORGOT_PASSWORD_MODAL_ID = 'FORGOT_PASSWORD_MODAL_ID';
